import AnalyticsMainHandler from '@common/utils/analytics/analytics.main';

function remindAboutImpersonation(app) {
  const action = {
    text: 'Stop',
    onClick: () => {
      stopImpersonation(app);
    },
  };
  app.$toasted.success(`Impersonating ${app.$store.getters.impersonatedUserEmailState}`, {action});
}

export function setImpersonation(app, userEmail) {
  app.$store.commit('setImpersonatedUserState', {email: userEmail});
  app.$store.commit('clearActiveFamilyTreeIdState');
  app.$toasted.success(`Impersonated ${app.$store.getters.impersonatedUserEmailState}`);
  AnalyticsMainHandler.stopTracking();
}

export function stopImpersonation(app) {
  app.$router.push({name: 'main-page'}).catch(() => {});
  app.$store.commit('setImpersonatedUserState', null);
  app.$store.commit('setImpersonatedUserFamilyTreeIdState', null);
  app.$store.commit('clearActiveFamilyTreeIdState');
  app.$toasted.success('Impersonation stopped');
  AnalyticsMainHandler.resumeTracking();
}

export function handleImpersonationOnRouteChange(from, to, app) {
  if (!from.name && app.$store.getters.impersonatedUserEmailState && !to.query.impersonate) {
    return remindAboutImpersonation(app);
  }
  if (to.query.impersonate) {
    if (app.$store.getters.userIsStaffState) {
      return setImpersonation(app, to.query.impersonate);
    }
    app.$toasted.error(`Log in as staff to impersonate ${to.query.impersonate}`, {duration: 5000});
  }
}
